<script>
   /**************************************************************/
   /* Outliers pane for training set                             */
   /* -------------------------                                  */
   /* loads training set from CSV file                           */
   /**************************************************************/

	import { createEventDispatcher } from 'svelte';
   import Container from '../controls/Container.svelte';
   import ButtonCancel from '../controls/ButtonCancel.svelte';

   // event dispatcher
   const dispatch = createEventDispatcher();

   // calibration set
   export let outliers;
   export let dataset;

   // function to dispatch event when outliers are reset
   function resetOutliers(el) {
      dispatch("resetoutliers", {});
   }
</script>

{#if outliers.length > 0 }
   <!-- dataset is loaded - show info and cancel button -->
   <Container>
      <p class="outliers">
         Removed: {@html outliers.map(v => '<span class="out">' + dataset.objlabels[v] + '</span>').join(' ')}
      </p>
      <ButtonCancel on:click={resetOutliers} />
   </Container>
{/if}


<style>
   .outliers{
      line-height: 1.5em;
      text-align: left;
      padding: 0.5em 0;
      flex: 0 0 80%;
   }

   .outliers > :global(.out) {
      color: #DC143C;
      background: #DC143C20;

      display: inline-block;
      white-space: nowrap;
      vertical-align: middle;
      max-width: 10ch;
      overflow: hidden;
      text-overflow: ellipsis;

      padding: 0.1em 0.5em;
      margin: 0.2em 0.1em;
      border-radius: 0.2em;
   }
</style>